export default {
  'webhookParameters.form.parameter': 'Parámetro',
  'webhookParameters.form.addParameter': 'Agregar parámetro',
  'webhookParameters.form.noParameters': 'Aún no hay parámetros. Agregue al menos uno.',
  'webhookParameters.form.inputParameterPosition': 'Posición del parámetro',
  'webhookParameters.form.inputParameterName': 'Nombre del parámetro',
  'webhookParameters.form.inputParameterCodification': 'Codificación del parámetro',
  'webhookParameters.form.destination': 'Destino',
  'webhookParameters.form.destinationForm': 'Formulario destino',
  'webhookParameters.form.destinationField': 'Campo destino',
  'webhookParameters.form.destinationFieldValueDestination': 'Tipo de valor de campo destino',
  'webhookParameters.form.destinationVariable': 'Variable destino',
  'webhookParameters.form.destinationAttachmentFileName': 'Nombre de archivo adjunto',
  'webhookParameters.form.destinationAttachmentContentType': 'Tipo de contenido del adjunto',
  'webhookParameters.form.destinationTableRowPropertyValue': 'Propiedad de fila de tabla',

  'webhookParameters.form.select.Header': 'Encabezado',
  'webhookParameters.form.select.Url': 'URL',
  'webhookParameters.form.select.FormData': 'Form Data',
  'webhookParameters.form.select.BodyJson': 'Body JSON',
  'webhookParameters.form.select.XWwwFormUrlEncoded': 'x-www-form-urlencoded',
  'webhookParameters.form.select.Authorization': 'Autorización',
  'webhookParameters.form.select.BodyText': 'Body texto',
  'webhookParameters.form.select.FormFileData': 'Form file data',

  'webhookParameters.form.select.None': 'Ninguna',
  'webhookParameters.form.select.ByteArray': 'Arreglo de bytes',
  'webhookParameters.form.select.Base64String': 'Cadena Base64',
  'webhookParameters.form.select.ZipByteArray': 'Arreglo de bytes ZIP',
  'webhookParameters.form.select.ZipBase64String': 'Cadena Base64 ZIP',
  'webhookParameters.form.select.HttpBodyBinaryData': 'Datos binarios en el cuerpo HTTP',

  'webhookParameters.form.select.FormField': 'Campo de formulario',
  'webhookParameters.form.select.Variable': 'Variable',
  'webhookParameters.form.select.InstanceName': 'Nombre de la solicitud',
  'webhookParameters.form.select.OperationObservations': 'Observaciones de la operación',
  'webhookParameters.form.select.OperationUserEmail': 'Correo del usuario de la operación',
  'webhookParameters.form.select.OperationIsApprovalOrReject': 'Es aprobación o rechazo',

  'webhookParameters.form.select.FieldValue': 'Valor del campo',
  'webhookParameters.form.select.FieldSearchValue': 'Valor de búsqueda del campo',
};
